import React from "react";

/**
 * Professional legend for the body diagram.
 *
 * Shows every state a muscle path can render in. Sits below the diagram.
 */
export default function DiagramLegend() {
  return (
    <div className="rounded-2xl border border-paper-200 bg-paper-50 p-4" data-testid="diagram-legend">
      <div className="label-overline mb-3">Legend</div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-2.5 text-xs text-ink-700">
        <Swatch fill="#F4EBD9" stroke="#A8927A" label="Resting" testid="legend-resting" />
        <Swatch fill="#B5BFAE" stroke="#7E8C73" label="Hover / tap" testid="legend-hover" />
        <Swatch fill="#C8553D" stroke="#9C4231" label="Primary focus" testid="legend-primary" textColor="text-terracotta-600" />
        <Swatch fill="#83926B" stroke="#6F7B59" label="Secondary focus" testid="legend-secondary" textColor="text-sage-700" />
        <Swatch fill="#D4A05B" stroke="#A07C42" label="Related / referral" testid="legend-related" textColor="text-amber-700" />
        <Swatch fill="#D4A373" stroke="#A07C5B" label="AI suggestion" testid="legend-ai" />
        <Swatch fill="#C8553D" stroke="#9C4231" label="Worked / selected" testid="legend-worked" textColor="text-terracotta-600" />
      </div>
    </div>
  );
}

function Swatch({ fill, stroke, label, textColor, testid }) {
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <span
        className="inline-block w-5 h-5 rounded-md border"
        style={{ background: fill, borderColor: stroke }}
      />
      <span className={textColor || "text-ink-700"}>{label}</span>
    </div>
  );
}
